export const generateArrayFromString = (str) => {
  const arr = (str || '')
    .replace(/([ .*+?^=!:${}()|\[\]\/\\])/g, ',') // eslint-disable-line
    .split(',')
    .filter(item => Boolean(item));
  return [...new Set(arr)];
};

export default {};
